<template>
  <div>
    <vs-input
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email"
        v-model="user.email"
        class="w-full
        required"/>

    <vs-input
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Password"
        v-model="user.password"
        class="w-full mt-6"
        required />

    <div class="flex flex-wrap justify-between mb-3 mt-6">
      <vs-button :disabled="!validateForm" @click="loginJWT">Login</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        email: '',
        password: ''
      },
      after: ''
    }
  },
  computed: {
    validateForm() {
      return this.user.email != '' && this.user.password != '';
    },
  },
  mounted() {
    this.setAfter()
  },
  methods: {
    loginJWT() {
      this.$vs.loading()

      fetch(this.$API_URL + "/login/", {
        method: "POST",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(this.user)
      })
      .then(response => response.json())
      .then(json => {
        if (json.message) {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Erro!',
            text: json.message,
            color:'danger'
          })
        } else if (json.token) {
          this.$vs.loading.close()
		  localStorage.setItem('token', json.token);
		  localStorage.setItem('role', json.role);

          if (this.after)
            this.$router.push(this.after)
          else
            this.$router.push("/tela-inicial/")
        }
      });
    },
    setAfter: function() {
      this.after = this.$route.query.to;
    }
  }
}

</script>
